import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const CustomStyles = () => {
    const [css, setCss] = useState('');

    useEffect(() => {
        // Listen for real-time updates to design settings
        const unsubscribe = onSnapshot(doc(db, 'settings', 'design'), (doc) => {
            if (doc.exists() && doc.data().customCss) {
                setCss(doc.data().customCss);
            }
        });

        return () => unsubscribe();
    }, []);

    if (!css) return null;

    return (
        <style dangerouslySetInnerHTML={{ __html: css }} />
    );
};

export default CustomStyles;
